module.exports = "a  {\r\n    color: #3f51b5\r\n}\r\n\r\na:hover {\r\n    color: #212121\r\n}\r\n\r\n\r\n\r\n"